<mat-sidenav-container
  hasBackdrop="true"
  class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0"
>
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>Paquetes de actividades por tipo de ruta. 
                Perfiles listos (preventa, autoventa, entrega).
                Úsalo para que todas las rutas similares trabajen
                igual.
            </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Funciones
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina las <b>funciones</b> que existen para una <b>ruta</b>, asignandole las <b>actividades</b> por <b>función</b>.
        </div>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between"
      >
        <div class="flex shrink-0">
             <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'master'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Función de Ruta</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <!-- Add button (only icon) -->
          <button
            mat-icon-button
            color="primary"
            (click)="openCreateModal()"
            matTooltip="Nuevo registro"
          >
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent"
            mat-table
            [dataSource]="dataSource"
            matSort
            [trackBy]="trackByFn"
          >
            <!-- Nombre -->
            <ng-container matColumnDef="name">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
              >
                Nombre
              </th>
              <td
                mat-cell
                *matCellDef="let subRouteFunction"
                class="text-sm uppercase leading-tight"
              >
                <b style="font-size: 10px">{{ subRouteFunction.code }}</b
                ><br />
                {{ subRouteFunction.name }}
              </td>
            </ng-container>

            <!-- Compañía -->
            <ng-container matColumnDef="company">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
              >
                Compañía
              </th>
              <td
                mat-cell
                *matCellDef="let subRouteFunction"
                class="text-sm uppercase"
              >
                <!-- <div><b>{{ subRouteFunction.company.id }}</b></div> -->
                <div>{{ subRouteFunction?.companies[0]?.name || 'N/A' }}</div>
              </td>
            </ng-container>

            <!-- Estado -->
            <ng-container matColumnDef="statusId">
              <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                Estado
              </th>
              <td
                mat-cell
                *matCellDef="let subRouteFunction"
                class="px-6 text-left"
              >
                <mat-slide-toggle
                  class="custom-slide-toggle primary"
                  [checked]="subRouteFunction.statusId == 1"
                  [(ngModel)]="subRouteFunction.statusId"
                  [color]="'success'"
                  (ngModelChange)="onStatusChange($event, subRouteFunction)"
                >
                </mat-slide-toggle>
              </td>
            </ng-container>

            <!-- Acciones -->
            <ng-container matColumnDef="actions">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="px-6 py-3 text-left"
              ></th>
              <td
                mat-cell
                *matCellDef="let subRouteFunction"
                class="px-6 py-3 text-left"
              >
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="actionMenu"
                  matTooltip="Acciones"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu">
                  <button
                    mat-menu-item
                    (click)="openEditModal(subRouteFunction)"
                  >
                    <mat-icon
                      svgIcon="heroicons_outline:pencil-square"
                    ></mat-icon>
                    <span>Editar Registro</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="openActivitieModal(subRouteFunction)"
                  >
                    <mat-icon svgIcon="heroicons_outline:rectangle-stack"></mat-icon>
                    <span>Actividades</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="openDeleteDialog(subRouteFunction)"
                  >
                    <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                    <span>Eliminar Registro</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <!-- Header Row -->
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns"
              class="sticky top-0 z-10  bg-white dark:bg-gray-900"
            ></tr>

            <!-- Fila principal -->
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="border-b"
            ></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator
            class="z-10"
            [pageSizeOptions]="[50, 100, 150, 200]"
            showFirstLastButtons
            [length]="totalItems"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            (page)="onPageChange($event)"
          ></mat-paginator>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Código</mat-label>
            <input
              matInput
              [(ngModel)]="currentCreateSubRouteFunction.code"
              name="code"
              required
            />
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Nombre</mat-label>
            <input
              matInput
              [(ngModel)]="currentCreateSubRouteFunction.name"
              name="name"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Modelo</mat-label>
            <mat-select [(ngModel)]="currentCreateSubRouteFunction.model"  name="model" required>
              <mat-option *ngFor="let model of modelList" [value]="model.value">
                {{ model.key | transloco }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label for="group-select">Compañías</mat-label>
            <mat-select
              [formControl]="companiesMultiCtrl"
              placeholder="Seleccione las compañías"
              [multiple]="true"
            >
              <mat-option>
                <ngx-mat-select-search
                  [showToggleAllCheckbox]="true"
                  [toggleAllCheckboxIndeterminate]="isIndeterminate"
                  [toggleAllCheckboxChecked]="isChecked"
                  (toggleAll)="toggleSelectAllCompanies($event)"
                  [formControl]="companiesMultiFilterCtrl"
                  [noEntriesFoundLabel]="'No se encontraron resultados'"
                  [clearSearchLabel]="'Limpiar búsqueda'"
                  [placeholderLabel]="'Buscar compañías...'"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let companies of filteredCompanies | async"
                [value]="companies"
              >{{ companies.name }}
              </mat-option>
            </mat-select>
            <!-- Mensaje de error si no se ha seleccionado ningún valor -->
            <mat-error
              *ngIf="
                companiesMultiCtrl.hasError('required') &&
                (companiesMultiCtrl.dirty || companiesMultiCtrl.touched)
              "
            >
              Seleccione compañías
            </mat-error>
          </mat-form-field>

          
          <mat-form-field appearance="fill" class="col-span-2">
            <mat-label for="group-select">Razones de Visita</mat-label>
            <mat-select
              [formControl]="visitMultiCtrl"
              placeholder="Seleccione las razones de visita"
              [multiple]="true"
            >
              <mat-option>
                <ngx-mat-select-search
                  [showToggleAllCheckbox]="true"
                  [toggleAllCheckboxIndeterminate]="isIndeterminateVisit"
                  [toggleAllCheckboxChecked]="isCheckedVisit"
                  (toggleAll)="toggleSelectAllVisit($event)"
                  [formControl]="visitMultiFilterCtrl"
                  [noEntriesFoundLabel]="'No se encontraron resultados'"
                  [clearSearchLabel]="'Limpiar búsqueda'"
                  [placeholderLabel]="'Buscar razones de visita...'"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let visit of filteredVisit | async"
                [value]="visit"
              >
              {{ visit.name }}  
            </mat-option>
            </mat-select>
            <!-- Mensaje de error si no se ha seleccionado ningún valor -->
            <mat-error
              *ngIf="
                visitMultiCtrl.hasError('required') &&
                (visitMultiCtrl.dirty || visitMultiCtrl.touched)
              "
            >
              Seleccione razones de visita
            </mat-error>
          </mat-form-field>
          <div class="col-span-2">
            <mat-slide-toggle
              [checked]="currentCreateSubRouteFunction.vehicleRequired == true"
              [(ngModel)]="currentCreateSubRouteFunction.vehicleRequired"
              [ngModelOptions]="{standalone: true}"
              color="primary"
            >
            <span class="slide">¿Requiere vehículo?</span>
            </mat-slide-toggle>
          </div>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button
          mat-raised-button
          color="primary"
          (click)="createSubRouteFunction()"
          [disabled]="!createForm.valid"
        >
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #editForm="ngForm" class="grid grid-cols-2 gap-4">
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Código</mat-label>
            <input
              matInput
              [(ngModel)]="currentUpdateSubRouteFunction.code"
              name="code"
              disabled
            />
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Nombre</mat-label>
            <input
              matInput
              [(ngModel)]="currentUpdateSubRouteFunction.name"
              name="name"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Modelo</mat-label>
            <mat-select [(ngModel)]="currentUpdateSubRouteFunction.model"  name="model" required>
              <mat-option *ngFor="let model of modelList" [value]="model.value">
                {{ model.key | transloco }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label for="group-select">Compañías</mat-label>
            <mat-select
              [formControl]="companiesMultiCtrl"
              placeholder="Seleccione las compañías"
              [multiple]="true"
            >
              <mat-option>
                <ngx-mat-select-search
                  [showToggleAllCheckbox]="true"
                  [toggleAllCheckboxIndeterminate]="isIndeterminate"
                  [toggleAllCheckboxChecked]="isChecked"
                  (toggleAll)="toggleSelectAllCompanies($event)"
                  [formControl]="companiesMultiFilterCtrl"
                  [noEntriesFoundLabel]="'No se encontraron resultados'"
                  [clearSearchLabel]="'Limpiar búsqueda'"
                  [placeholderLabel]="'Buscar compañías...'"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let companies of filteredCompanies | async"
                [value]="companies"
              >
               {{ companies.name }}
              </mat-option>
            </mat-select>
            <!-- Mensaje de error si no se ha seleccionado ningún valor -->
            <mat-error
              *ngIf="
                companiesMultiCtrl.hasError('required') &&
                (companiesMultiCtrl.dirty || companiesMultiCtrl.touched)
              "
            >
              Seleccione compañías
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-span-2">
            <mat-label for="group-select">Razones de Visita</mat-label>
            <mat-select
              [formControl]="visitMultiCtrl"
              placeholder="Seleccione las razones de visita"
              [multiple]="true"
            >
              <mat-option>
                <ngx-mat-select-search
                  [showToggleAllCheckbox]="true"
                  [toggleAllCheckboxIndeterminate]="isIndeterminateVisit"
                  [toggleAllCheckboxChecked]="isCheckedVisit"
                  (toggleAll)="toggleSelectAllVisit($event)"
                  [formControl]="visitMultiFilterCtrl"
                  [noEntriesFoundLabel]="'No se encontraron resultados'"
                  [clearSearchLabel]="'Limpiar búsqueda'"
                  [placeholderLabel]="'Buscar razones de visita...'"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let visit of filteredVisit | async"
                [value]="visit"
              >
              {{ visit.name }}
              </mat-option>
            </mat-select>
            <!-- Mensaje de error si no se ha seleccionado ningún valor -->
            <mat-error
              *ngIf="
                visitMultiCtrl.hasError('required') &&
                (visitMultiCtrl.dirty || visitMultiCtrl.touched)
              "
            >
              Seleccione razones de visita
            </mat-error>
          </mat-form-field>
          <div class="col-span-2">
            <mat-slide-toggle
              [checked]="currentUpdateSubRouteFunction.vehicleRequired == true"
              [(ngModel)]="currentUpdateSubRouteFunction.vehicleRequired"
              [ngModelOptions]="{standalone: true}"
              color="primary"
            >
            <span class="slide">¿Requiere vehículo?</span>
            </mat-slide-toggle>
          </div>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button
          mat-raised-button
          color="primary"
          (click)="updateSubRouteFunction(currentUpdateSubRouteFunction._id)"
          [disabled]="!editForm.valid"
        >
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Itinerario  -->
    <ng-template #addModalActivitie>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Actividades
      </h2>
      <mat-dialog-content class="modal-content-itinerary">
        <div>
          <table
            mat-table
            [dataSource]="currentUpdateSubRouteFunction.activities"
            class="min-w-500 overflow-y-visible mat-elevation-z"
          >
            <ng-container matColumnDef="activity">
              <th mat-header-cell *matHeaderCellDef>Actividad</th>
              <td mat-cell *matCellDef="let element">
                {{ element.activity?.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="reason_visit">
              <th mat-header-cell *matHeaderCellDef>Razón de Visita</th>
              <td mat-cell *matCellDef="let element">
                {{ element.defaultReasonVisit?.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let element">
                <mat-slide-toggle
                  [checked]="element.statusId === 1"
                  (change)="onActivitieStatusChange($event.checked, element)"
                  color="primary"
                >
                </mat-slide-toggle>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>
                <button
                color="primary"
                mat-button
                (click)="openAddActivitieModal(element)"
                matTooltip="Nuevo Registro"
              >
                <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
              </button>
              </th>
              <td mat-cell *matCellDef="let element">
                <div class="button-container">
                  <button
                    mat-icon-button
                    (click)="openAddActivitieModal(element)"
                    matTooltip="Editar Registro"
                  >
                    <mat-icon
                      svgIcon="heroicons_outline:pencil-square"
                    ></mat-icon>
                  </button>
                  <button
                  mat-icon-button
                  (click)="openDeleteActivity(element)"
                  matTooltip="Eliminar Registro"
                >
                  <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsI"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsI"></tr>
          </table>
          <!-- Paginación -->
        </div>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Eliminar -->
    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon
            svgIcon="heroicons_outline:exclamation-triangle"
            class="text-red-500 ml-4 mt-6"
            style="font-size: 32px"
          ></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            Confirmar eliminación
          </h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
          Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
          Eliminar
        </button>
      </mat-dialog-actions>
    </ng-template>
  </div>

  <!-- Filtros -->
  <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="clearFilters()" (onPanelOpened)="onFilterPanelOpened()">
    <app-configuration-filters [form]="form" [company]="true" [loadData]="loadFiltersData"></app-configuration-filters>
    <app-routes-filters [form]="form" [model]="true" [loadData]="loadFiltersData"></app-routes-filters>
  </app-filter>
</mat-sidenav-container>
